import React from 'react';
import JobOpportunityCard from '@/components/seo/JobOpportunityCard';
import { GroupedHotJobsType } from '@/types/job-detail';

const HotJobs = ({ hotJobs }: { hotJobs: GroupedHotJobsType }) => {
  const [jobCategoryId, setJobCategoryId] = React.useState<string>(
    hotJobs?.length > 0 ? hotJobs[0].id : '',
  );
  if (!Array.isArray(hotJobs) || !hotJobs.length) {
    return null;
  }

  return (
    <div className="my-16">
      <h3 className="text-2xl font-semibold mb-10">热招职位</h3>
      <h4 className="flex justify-between gap-2 mb-8 overflow-x-scroll tablet:overflow-auto">
        {hotJobs.map(({ id, name }, index) => (
          <span
            role="button"
            key={id + index}
            data-selected={id === jobCategoryId}
            className="px-8 py-2 rounded-full text-sm border border-web-tertiary font-semibold whitespace-nowrap transition-colors duration-250 data-[selected=true]:text-white data-[selected=true]:bg-web-blue-500 data-[selected=true]:border-web-blue-600 data-[selected=false]:hover:bg-web-blue-500/4 data-[selected=false]:hover:border-web-blue-600"
            onClick={() => setJobCategoryId(id)}
          >
            {name}
          </span>
        ))}
      </h4>
      <div className="mt-8">
        {hotJobs.map(({ id, jobs }, index) => (
          <div
            key={id + index}
            hidden={id !== jobCategoryId}
            className="grid gap-8 gap-y-4 grid-cols-3"
          >
            {jobs.map((item, index) => (
              <JobOpportunityCard key={item.id + index} data={item} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default HotJobs;
